import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    //id: IdRef, optional // Mã người dùng
    so_the: null, // string, optional // Mã thẻ
    ho_ten: { // object, optional
        ho_ten: null, // string, optional // Họ tên đầy đủ
    },
    email: null, // string, optional // Email
    dien_thoai: null, // string, optional // Số điện thoại
    gioi_tinh: null, // integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
    ngay_sinh: { // object, optional // Ngày tháng năm sinh
        ngay: null, // integer, optional // Ngày
        thang: null, // integer, optional // Tháng
        nam: null, // integer, optional // Năm
        ngay_sinh: null, // datetime, optional // Ngày sinh
    },
    giay_to: [], //array of object, optional // Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu
    // loai_giay_to: string, optional // Loại giấy tờ
    // so_giay_to: string, optional // Số giấy tờ
    // noi_cap: string, optional // Nơi cấp
    // ngay_cap: datetime, optional // Ngày cấp
    // ngay_het_han: datetime, optional // Ngày hết hạn
    quoc_tich: { //object, optional // Quốc tịch
        quoc_tich_id: null, // IdRef, optional // Mã quốc tịch
        ten_quoc_tich: null, // string, optional // Tên quốc tịch
    },
    dia_chi: { // object, optional // Địa chỉ
        province_id: null, // IdRef, optional // Mã tỉnh/TP
        province_name: null, // string, optional // Tên tỉnh/TP
        district_id: null, // IdRef, optional // Mã quận/huyện
        district_name: null, // string, optional // Tên quận/huyện
        dia_chi: null, // string, optional // Địa chỉ đầy đủ
    },
    avatar_id: null, // IdRef, optional // Mã ảnh đại diện

    star: null,
    doi_tuong_id :null,
    count: null,

};

// validation form
model.validForm = {
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    giay_to: {
        loai_giay_to: null, //string, required // Loại giấy tờ
        so_giay_to: null, //string, required // Số giấy tờ
        noi_cap: null, //string, optional // Nơi cấp
        ngay_cap: null, //datetime, optional // Ngày cấp
        ngay_het_han: null, //datetime, optional // Ngày hết hạn
    }
};

// validation các form khác
model.validFormOther = {
};


model.tableRules = {
    data: [],
    type: 'tourist',
    sort_type:1,
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "star",
    defaultSort: ["star", "ascending"],
    filters: "",
    words:'',
    recordSelected: [],
    dataSearch: {
        value: {
            "ho_ten.ho_ten": "",
            "email": "",
            "dien_thoai": "",
            "so_the": "",
            star: '', count: ''
        },
        valid: {
        },
        operator: {
            "ho_ten.ho_ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
            "email": ":regex_i:",
            "dien_thoai": ":regex_i:",
            "so_the": ":regex_i:",
            star: '>=', count: '>='
        }
    }
};

export default model;